import { Component, OnInit, ViewChild } from '@angular/core';
import { ZoneService } from '../../../../../services/zone.service';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { Validation } from '../../../error/error-messages/validator-messages';
import { Zone } from '../../../../../models/zone.model';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';

@Component({
  selector: 'app-zone',
  templateUrl: './zone.component.html',
  styleUrls: ['./zone.component.scss']
})
export class ZoneComponent implements OnInit {

  @ViewChild('closebutton') closebutton;
  @ViewChild('closebutton2') closebutton2;

  // @ts-ignore
  zone: Zone[] = [];
  zoneTmp: Zone[] = [];
  // @ts-ignore
  currentZone: IZone = [];

  search: any;
  page = 1;
  perPage = 10;
  sorted = false;
  sorted1 = false;

  constructor(private fb: FormBuilder, private zoneService: ZoneService,
              private router :Router) { }

  ngOnInit(): void {
    this.loadZone();
  }

  zoneForm = this.fb.group({
    name: new FormControl('', [ Validation.requiredValidator("Le nom"),]),
  });


  editForm = this.fb.group({
    name: new FormControl('', [ Validators.required]),
  });

  loadZone = () => {
    this.zoneService.getZone()
      .subscribe((data: any) => {
        //console.log("Zoneeeeeeee");
        //console.log(data);
        this.zone = data;
        this.zoneTmp = data;
        }, (err) => {
       // console.log('-----> err', err);
      });
  }

  onEditZone(id: any) {
    this.isTrueName = false;
    this.zoneService.getIdZone(id).subscribe(rs => {
      this.currentZone = rs;
      this.editForm = this.fb.group({
        id: new FormControl(this.currentZone.id, [ ]),
        name: new FormControl(this.currentZone.name, [ Validators.required]),
      });
    });
  }

  onZoneFormSubmit() {
    //console.log(this.zoneForm.value);
    const zone: Zone = this.zoneForm.value;

    this.zoneService.saveZone(zone).subscribe(rs => {
     // console.log(rs);
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'La zone a été ajoutée avec succès"',
        showConfirmButton: false,
        timer: 1500
      });
      this.loadZone();
      this.close();
      this.reloadComponent();
    }, error => {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez vérifier les données',
        showConfirmButton: false,
        timer: 2500
      });
    });
  }

  reloadComponent() {
    let currentUrl = this.router.url;
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigate([currentUrl]);
  }

  onEditFormSubmit() {
   // console.log(this.editForm.value);
    const zone: Zone = this.editForm.value;
    this.zoneService.updateZone(zone).subscribe(rs => {
     // console.log(rs);
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'La zone a été modifiée avec succès"',
        showConfirmButton: false,
        timer: 1500
      });
      this.loadZone();
      this.close();
    }, error => {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez verifier les données',
        showConfirmButton: false,
        timer: 2500
      });
    });
  }

  isTrueName = false;
  getIfIsExistedZone(zoneName : any): boolean{
    let testName = zoneName.target.value;
    let testbool = true;
    this.zone.forEach(element =>{
      if(testbool){
        if(element.name){
          if(element.name.toUpperCase() === testName.toUpperCase()){
            testbool = false;
            this.isTrueName = true;
          }else{
            this.isTrueName = false;
          }
        }
      }
    });
    return this.isTrueName;
  }

  getIfIsExistedZone1(zoneName : any): boolean{
    let testName = zoneName.target.value;
    let testbool = true;
    this.zone.forEach(element =>{
      if(testbool){
        if(element.name){
          if((element.name.toUpperCase() === testName.toUpperCase()) && element.name.toUpperCase() != this.currentZone?.name.toUpperCase()){
            testbool = false;
            this.isTrueName = true;
          }else{
            this.isTrueName = false;
          }
        }
      }
    });
    return this.isTrueName;
  }

  deleteZone(id: any) {
    Swal.fire({
      title: 'SUPPRESSION',
      text: 'Voulez-vous vraiment supprimer cette zone ?',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'OUI',
      denyButtonText: `NON`,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        this.zoneService.deleteZone(id).subscribe(
        rs => {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'La zone a été supprimée avec succès"',
            showConfirmButton: false,
            timer: 1500
          });
          this.loadZone();
        }
      );
      } else if (result.isDenied) {
        Swal.fire({
          icon: 'error',
          text: 'Suppression annulée',

        })
      }
    })

  }

  displayPerPage(value: any) {
    this.perPage = parseInt(value, 10);
    //console.log(this.perPage);
  }

  searchFilter($event: KeyboardEvent) {
    //console.log(this.search);
    this.zone = this.zoneTmp.filter(value =>
        value.name?.toUpperCase().includes(this.search) ||  value.name?.toLowerCase().includes(this.search)
    );
  }

  sort1() {
    if(this.sorted1 == false) {
      // @ts-ignore
      this.zone.sort((a, b) => a.name > b.name ? 1 : a.name < b.name ? -1 : 0)
      this.sorted1 = true;
    } else {
      // @ts-ignore
      this.zone.sort((a, b) => a.name < b.name ? 1 : a.name > b.name ? -1 : 0)
      this.sorted1 = false;
    }
  }

  close() {
    this.closebutton.nativeElement.click();
    this.closebutton2.nativeElement.click();
  }

}
